import React, { useState, useEffect } from 'react';
import UserDetailsForm from 'components/userDetailsForm/userDetailsForm';
import { STWContext } from 'widgets/STW/context';
import { IDRTemplate } from '../index';
import { decodeTextHelper } from '../../utility';
import { WIDGET_NAME } from '@bikdotai/bik-models/dm';
import { ComponentStyleMap } from '../../../utilities/styleUtils';

const UserDetails = (props: IDRTemplate) => {
  const {
    templateName,
    isMobile,
    preview,
    claimPrizeHandle,
    widgetCustomisation,
    leadGeneration,
    error,
    isLoading,
    widgetLanguage,
  } = props;
  const [currentStyle, setCurrentStyle] = useState<any>(null);
  const multiLingualData =
    widgetCustomisation?.multiLingualConfigurations?.[widgetLanguage];

  let playScreenTitleSize: string;
  let playScreenSubTitleSize: string;

  if (preview) {
    playScreenTitleSize = isMobile ? '14px' : '13px';
    playScreenSubTitleSize = isMobile ? '11px' : '10px';
  } else {
    playScreenTitleSize = props.isMobileDevice ? '20px' : `26px`;
    playScreenSubTitleSize = props.isMobileDevice ? '14px' : `16px`;
  }

  useEffect(() => {
    if (preview && isMobile) {
      ComponentStyleMap[templateName]?.userInputPreviewMobile.then(
        async style => {
          setCurrentStyle((await style()).default);
        },
      );
    } else if (preview && !isMobile) {
      ComponentStyleMap[templateName]?.userInputPreviewDesktop.then(
        async style => {
          setCurrentStyle((await style()).default);
        },
      );
    } else {
      ComponentStyleMap[templateName]?.globalStyle.then(async style => {
        setCurrentStyle((await style()).default);
      });
    }
  }, [preview, isMobile]);

  if (!currentStyle) {
    return <></>;
  }
  return (
    <div
      className={currentStyle.bikDRContentWrapper}
      id={`bik-dr-${props.id}-user-details-container`}
    >
      <div className={currentStyle.bikDRTitleWrapper}>
        <div
          className={currentStyle.bikDRTitle}
          style={{
            fontSize: playScreenTitleSize,
            fontFamily: props.widgetCustomisation.fontFamily?.name,
            color: widgetCustomisation?.fontColour,
          }}
          dangerouslySetInnerHTML={{
            __html: decodeTextHelper(
              multiLingualData?.playScreenTitle ??
                widgetCustomisation?.playScreenTitle,
            ),
          }}
        />
        {(multiLingualData?.playScreenSubTitle ??
          widgetCustomisation?.playScreenSubTitle) && (
          <div
            className={currentStyle.bikDRSubTitle}
            style={{
              fontSize: playScreenSubTitleSize,
              fontFamily: props.widgetCustomisation.fontFamily?.name,
              color: widgetCustomisation?.fontColour,
            }}
            dangerouslySetInnerHTML={{
              __html: decodeTextHelper(
                multiLingualData?.playScreenSubTitle ??
                  widgetCustomisation?.playScreenSubTitle,
              ),
            }}
          />
        )}
      </div>
      <STWContext.Provider value={{ preview, isMobile, templateName }}>
        <UserDetailsForm
          id={props.id}
          claimPrizeHandle={claimPrizeHandle as any}
          widgetCustomisation={widgetCustomisation}
          leadGeneration={leadGeneration}
          error={error}
          isLoading={isLoading}
          templateName={WIDGET_NAME.DIRECT_REWARD}
          showTitle={false}
          skipSubtitle={true}
          widgetName="Direct_Reward"
          countryCode={props.countryCode}
          widgetLanguage={widgetLanguage}
        />
      </STWContext.Provider>
    </div>
  );
};

export default UserDetails;
